import classNames from "classnames";
import React from "react";
import { CURRENCY_SYMBOL } from "utils/constants";
import { costToFrench } from "utils/helpers/values";
import checkboxCheckedInverted from "../Assets/icons/checkbox_checked_inverted.svg";
import checkboxUnchecked from "../Assets/icons/checkbox_unchecked.svg";

function UpsellsCard({
  name,
  description,
  cost,
  currency,
  perMonthLabel,
  onAdd,
  notSelected,
  benefits = [],
}) {
  const isSelected = !notSelected;

  return (
    <button
      type="button"
      className={classNames("acoris-upsells__card", {
        "acoris-upsells__card--selected": isSelected,
      })}
      onClick={onAdd}
    >
      <div className="acoris-upsells__card-header">
        <span className="acoris-upsells__checkbox" aria-hidden>
          <img
            src={isSelected ? checkboxCheckedInverted : checkboxUnchecked}
            alt=""
          />
        </span>

        <span className="acoris-upsells__card-titles">
          <span className="acoris-upsells__card-name">{name}</span>
          {description && (
            <span className="acoris-upsells__card-subtitle">{description}</span>
          )}
        </span>

        <span className="acoris-upsells__card-price">
          <span className="acoris-upsells__card-price-amount">
            {costToFrench(cost)} {CURRENCY_SYMBOL[currency] || "€"}
          </span>
          <span className="acoris-upsells__card-price-period">
            {perMonthLabel}
          </span>
        </span>
      </div>
      {benefits.length > 0 && (
        <div className="acoris-upsells__card-benefits">
          {benefits.map((benefit, index) => (
            <React.Fragment key={index}>
              <div className="acoris-upsells__benefit-row">
                <span className="acoris-upsells__benefit-label">
                  {benefit.mainInfo || benefit.coverage}
                </span>
                <span className="acoris-upsells__benefit-value">
                  {benefit.description || benefit.limit}
                </span>
              </div>
              {index < benefits.length - 1 && (
                <div className="acoris-upsells__benefit-divider" />
              )}
            </React.Fragment>
          ))}
        </div>
      )}
    </button>
  );
}

export default React.memo(UpsellsCard);
